(function () {
    'use strict';
    angular.module('app').controller('TriggerModalController', TriggerModalController);

    TriggerModalController.$inject = [
        '$uibModalInstance',
        'ViewChangeNotificationFactory',
        'ConfirmationModalFactory',
        'trigger',
        'ComplianceService',
        'compliance',
        'ComplianceConst',
        '$q',
        'ObjectHelpersService',
        'FormHelpersService',
        'toastr',
        'tableData'
    ];

    function TriggerModalController(
        $uibModalInstance,
        ViewChangeNotificationFactory,
        ConfirmationModalFactory,
        trigger,
        ComplianceService,
        compliance,
        ComplianceConst,
        $q,
        ObjectHelpersService,
        FormHelpersService,
        toastr,
        tableData
    ) {
        const vm = this;
        vm.onSaveButtonClicked = onSaveButtonClicked;
        vm.onCancelButtonClicked = onCancelButtonClicked;
        vm.onSearchComplianceReminders = onSearchComplianceReminders;

        function getComplianceReminders(filter) {
            const defer = $q.defer();
            ComplianceService.reminders.getAll(data => {
                defer.resolve(data.content);
            }, error => {
                toastr.error('Unable to fetch compliance reminders', error.message);
                defer.reject(error);
            }, angular.extend(filter, { 'complianceItem.id': compliance.id }));
            return defer.promise;
        }

        function getUnusedComplianceReminderItems(data) {
            return data.filter(reminder => {
                const foundData = tableData.find(usedReminder => usedReminder.complianceReminder.id === reminder.id);
                if (angular.isUndefined(foundData)) {
                    return reminder;
                }
            });
        }

        function onSearchComplianceReminders(search) {
            vm.searchingComplianceReminders = true;
            getComplianceReminders({ name: search }).then(data => {
                vm.complianceRemindersList = getUnusedComplianceReminderItems(data);
                vm.searchingComplianceReminders = false;
            });
        }

        function cleanPayload(trigger) {
            return {
                complianceItemId: compliance.id,
                complianceReminderId: trigger.complianceReminder.id,
                triggerEvent: trigger.triggerEvent,
            }
        }

        function isOriginalTriggerDataEmpty() {
            return ObjectHelpersService.isObjectEmpty(vm.triggerRaw);
        }

        function createNewTrigger() {
            vm.isSavingTrigger = true;
            const defer = $q.defer();
            ComplianceService.triggers.create(data => {
                toastr.success('Trigger saved!');
                vm.isSavingTrigger = false;
                defer.resolve(data);
            }, error => {
                toastr.error('Unable to save trigger.', error.message);
                vm.isSavingTrigger = false;
                defer.reject(error);
            }, cleanPayload(vm.trigger));
            return defer.promise;
        }

        function updateTrigger() {
            vm.isSavingTrigger = true;
            const defer = $q.defer();
            ComplianceService.triggers.update(data => {
                vm.isSavingTrigger = true;
                toastr.success('Trigger updated!');
                $uibModalInstance.close(vm.trigger);
            }, error => {
                vm.isSavingTrigger = false;
                toastr.error('Unable to update trigger', error.message);
                defer.reject(error);
            }, vm.trigger.id, cleanPayload(vm.trigger));
            return defer.promise;
        }

        function saveTriggerData() {
            if (isOriginalTriggerDataEmpty()) {
                createNewTrigger().then(data => {
                    $uibModalInstance.close(vm.trigger);
                });
            } else {
                updateTrigger().then(data => {
                    $uibModalInstance.close(vm.trigger);
                });
            }
        }

        function validateForms(forms) {
            FormHelpersService.setFormsToSubmitted(forms);
            return FormHelpersService.getInvalidForms(forms);
        }

        function onSaveButtonClicked(...forms) {
            const invalidForms = validateForms(forms);
            if (invalidForms.length !== 0) { return false; }
            saveTriggerData();

        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }

        function onCancelButtonClicked() {
            closeModal();
        }

        function setEventsData() {
            vm.events = ComplianceConst.events;
        }

        function setTriggerData() {
            vm.trigger = trigger;
        }

        function setTriggerDataOriginalCopy() {
            vm.triggerRaw = angular.copy(trigger);
        }

        function init() {
            setTriggerData();
            setTriggerDataOriginalCopy();
            setEventsData();
        }

        init();
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/compliance/modals/TriggerModalController.js